import React, { Component } from "react";

export default class Introduction extends Component {
  componentDidMount() {
    this._ismounted = true;
    window.slider();
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  render() {
    return (
      <section id="Home" className="Home" data-section="Home">
        <div id="slideshow">
          <div id="layer1" hidden={true}>
            <img
              src="/images/doublethefun_Banner.png"
              alt="Double The Passion! Double The Effort!"
              height="98%"
              width="100%"
            />
          </div>
          <div id="layer2" hidden={true}>
            <img
              src="/images/doublethefun_Banner2.png"
              alt="Double The Passion! Double The Action!"
              height="98%"
              width="100%"
            />
          </div>
          <div id="layer3" hidden={true}>
            <img
              src="/images/doublethefun_Banner3.png"
              alt="Double The Passion! Double The Fun!"
              height="98%"
              width="100%"
            />
          </div>
        </div>
        <div id="dotContainer" className="text-center">
          <span className="dot" onClick={() => window.currentSlide(0)}></span>
          <span className="dot" onClick={() => window.currentSlide(1)}></span>
          <span className="dot" onClick={() => window.currentSlide(2)}></span>
        </div>
      </section>
    );
  }
}
